import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class CustomTranslateLoader implements TranslateLoader {

    contentHeader = new HttpHeaders({ "Content-Type": "application/json", "Access-Control-Allow-Origin": "*" });

    constructor(private http: HttpClient) { }

    getTranslation(lang: string): Observable<any> {
        var apiAddress = "https://s3.eu-central-1.amazonaws.com/public.q7leader.com/TRA/i18n/" + lang + ".json";
        return Observable.create(observer => {
            this.http.get(apiAddress, { headers: this.contentHeader }).subscribe((res: Response) => {
                observer.next(res);
                observer.complete();
            }, (error) => {
                //  failed to retrieve from api, switch to local
                window.onerror('custom translate loader page error getting language data from server : ' + JSON.stringify(error), window.location.href, 22, 0);
                this.http.get("assets/i18n/" + lang + ".json").subscribe((res: Response) => {
                    observer.next(res);
                    observer.complete();
                })
            });
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/custom-translate-loader.ts